import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-dictation-page',
  imports: [RidButton, RidDemoPage],
  templateUrl: './dictation-page.html',
})
export class DictationPage {}
